import UUID from 'pure-uuid'

import { TrailingLoading } from '../Icons'
import { Messaging as MessagingType } from './types'
import { Message } from './Components'

const Messaging = ({ messages, isWaitingResponse }: MessagingType) => {
  return (
    <>
      {messages?.map((data) => (
        <Message {...data} key={`chat-message-${new UUID(1)}`} />
      ))}

      {isWaitingResponse && (
        <Message
          type="income"
          message={<TrailingLoading />}
          data-testid="message-baloon-waiting"
        />
      )}
    </>
  )
}

export default Messaging
